import React from 'react';
import FolderSliderContainer, { OwnProps } from './FolderSlider.container';
import FolderSlider from './FolderSlider';

export default FolderSliderContainer(FolderSlider) as React.ComponentType<
  OwnProps
>;
